import { ProfilePageState, ProfilePageActionTypes } from 'interfaces'
import { IUser } from '../../interfaces/user'

type Action =
  | { type: ProfilePageActionTypes.SET_PROFILE; payload: IUser }
  | { type: ProfilePageActionTypes.SET_EDIT; payload: boolean }

export const profilePageReducer = (
  state: ProfilePageState,
  action: Action
): ProfilePageState => {
  switch (action.type) {
    case ProfilePageActionTypes.SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      }
    case ProfilePageActionTypes.SET_EDIT:
      return {
        ...state,
        isEdit: action.payload,
      }
    default:
      return state
  }
}
